import { useStore } from '../store.js';

export function LintView() {
  const { doc, errors, warnings, parseError } = useStore();

  if (parseError) {
    return (
      <div className="p-6">
        <h2 className="label">Parse error</h2>
        <div className="mono mt-2 max-w-3xl border-l-2 border-status-deprecated bg-ink-900 p-3 text-xs">
          {parseError}
        </div>
      </div>
    );
  }

  if (!doc) {
    return (
      <div className="p-6 text-[13px] text-ink-500">Open a Remedy to see lint output.</div>
    );
  }

  return (
    <div className="h-full overflow-auto p-6">
      <div className="max-w-3xl">
        <h2 className="mb-4 text-[14px] font-semibold text-ink-100">
          {errors.length} error(s), {warnings.length} warning(s)
        </h2>
        {errors.length === 0 && warnings.length === 0 && (
          <div className="mono rounded border border-status-deployed/40 bg-status-deployed/5 p-3 text-xs text-status-deployed">
            Lint clean. Ship it.
          </div>
        )}
        {errors.length > 0 && (
          <>
            <h3 className="label mt-4 mb-2">Errors</h3>
            {errors.map((e, i) => (
              <Row key={`e-${i}`} tone="error" {...e} />
            ))}
          </>
        )}
        {warnings.length > 0 && (
          <>
            <h3 className="label mt-6 mb-2">Warnings</h3>
            {warnings.map((w, i) => (
              <Row key={`w-${i}`} tone="warning" {...w} />
            ))}
          </>
        )}
      </div>
    </div>
  );
}

function Row({
  tone,
  code,
  path,
  message,
}: {
  tone: 'error' | 'warning';
  code: string;
  path?: string;
  message: string;
}) {
  const color = tone === 'error' ? 'border-status-deprecated' : 'border-status-building';
  return (
    <div className={`mono my-1.5 border-l-2 ${color} bg-ink-900 p-3 text-xs`}>
      <div className="text-[11px] text-ink-500">
        [{code}] {path ?? '/'}
      </div>
      <div className="mt-0.5 text-ink-200">{message}</div>
    </div>
  );
}
